export default {
    login: 'تسجيل الدخول'
}